<template>
  <div>
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="product">
      <ul class="product_img">
        <li class="product_img_item" v-if="data.img">
          <img :src="require('../../assets/message/' + data.img)">
        </li>
        <li class="product_img_item">
          {{ data.title }}
        </li>
        <li style="margin-top: 10px;">
          {{ data.content }}
        </li>

      </ul>
    </div>

  </div>
</template>

<script>
import listJson from './message.json'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    // 回获取路由参数
    const { id } = this.$route.query;
    let data = listJson.find(item => item.id === id);
    this.data = data;
    console.log(data);

  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 3 } })
    }
  },
}
</script>
<style lang="less" scoped>
.product {
  padding: 20px;

  .product_img {
    width: 100%;

    .product_img_item {
      width: 100%;
      font-size: 0.14rem;
      font-weight: bold;
      margin: 10px 0;

      img {
        width: 100%;
      }
    }
  }
}
</style>